var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pt-2"},[_c(_setup.VIcon,{staticClass:"am-blue--text"},[_vm._v(" "+_vm._s(_setup.mdiArrowRight)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }